import type { ThemeDeclaration } from '@blufin/theme';
import { blufinDefault } from './BlufinDefault/blufinDefault';

/**
 * Default theme set registered by Blufin marketing sites (`sites/*`). Each site's `themes.ts`
 * re-exports this so the (identical) list is declared once. Consumed by `next.config.ts`.
 */
export const siteThemes: ThemeDeclaration[] = [blufinDefault];
